/**
 * OTP Drill Down Mixin
 * Handles navigation to Trips screen with preserved filters
 */

export default {
  methods: {
    navigateToTrips(params) {
      const { date, routes, direction, routeId } = params;

      // Build query parameters
      const query = {};

      // Add date filter
      if (date) {
        if (typeof date === 'string') {
          query.date = date;
        } else if (date.fromDate && date.toDate) {
          query.fromDate = date.fromDate;
          query.toDate = date.toDate;
        }
      }

      // Add route filter
      if (routeId) {
        query.routeId = routeId;
      } else if (routes && routes.length > 0 && !routes.includes('all')) {
        query.routes = routes.join(',');
      }

      // Add direction filter
      if (direction && direction !== 'all') {
        query.direction = direction;
      }

      // Navigate to Trips screen with filters
      this.$router.push({
        name: 'trips',
        query,
      });
    },
    navigateToRouteDetail(routeId) {
      if (!routeId) {
        console.error('Route ID is required');
        return;
      }

      // Open route detail in new tab
      const routeDetailUrl = `${window.location.origin}/admin/flexigo/#/route-detail/${routeId}`;
      window.open(routeDetailUrl, '_blank');
    },
    buildTripsUrl(params) {
      const { date, routes, direction, routeId } = params;
      const baseUrl = `${window.location.origin}/admin/flexigo/#/trips`;
      const queryParams = [];

      if (date) {
        if (typeof date === 'string') {
          queryParams.push(`date=${encodeURIComponent(date)}`);
        } else if (date.fromDate && date.toDate) {
          queryParams.push(`fromDate=${encodeURIComponent(date.fromDate)}`);
          queryParams.push(`toDate=${encodeURIComponent(date.toDate)}`);
        }
      }

      if (routeId) {
        queryParams.push(`routeId=${encodeURIComponent(routeId)}`);
      } else if (routes && routes.length > 0 && !routes.includes('all')) {
        queryParams.push(`routes=${encodeURIComponent(routes.join(','))}`);
      }

      if (direction && direction !== 'all') {
        queryParams.push(`direction=${encodeURIComponent(direction)}`);
      }

      return queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;
    },
    preserveFiltersInNavigation() {
      // Save current filters before navigation
      if (this.filters) {
        try {
          sessionStorage.setItem('otp_navigation_filters', JSON.stringify(this.filters));
        } catch (error) {
          console.error('Error saving navigation filters:', error);
        }
      }
    },
    restoreFiltersFromNavigation() {
      // Restore filters after navigation back
      try {
        const saved = sessionStorage.getItem('otp_navigation_filters');
        if (saved) {
          const filters = JSON.parse(saved);
          if (this.updateFilters) {
            this.updateFilters(filters);
          }
          sessionStorage.removeItem('otp_navigation_filters');
        }
      } catch (error) {
        console.error('Error restoring navigation filters:', error);
      }
    },
  },
  mounted() {
    // Check if returning from navigation
    this.restoreFiltersFromNavigation();
  },
};
